import { MERCHANT_ROLES_MAPPING } from '@/lib/constants';

export { filterSteps, unfilterSteps } from './filterSteps';

export const getMonday = (d) => {
    d = new Date(d);
    var day = d.getDay(),
        diff = d.getDate() - day + (day === 0 ? -6:1); // adjust when day is sunday
    return new Date(d.setDate(diff));
}

export const formatHour = (hour) => {
  const parts = hour.split(':');

  return parts[0] + ':' + parts[1];
}

export const getInitials = (nameString) => {
  const fullName = nameString.split(' ');
  if (fullName.length > 1){
    const initials = fullName.shift().charAt(0) + fullName.shift().charAt(0);
    return initials.toUpperCase();
  }else if (fullName.length > 0) {
    const initials = fullName.shift().charAt(0);
    return initials.toUpperCase();
  }else{
    return '';
  }
}

export const pluck = (arr, key) => arr.map(i => i[key]);

export const beautifyDate = (date, weekday = true, day = true, year = false) => {
    
    if (isToday(date)) {
        return 'Aujourd\'hui';
    }

    let the_day = date.getDay();
    let day_label;
    switch(the_day) {
      case 0:
        day_label = 'Dimanche';
        break;
      case 1:
        day_label = 'Lundi';
        break;
      case 2:
        day_label = 'Mardi';
        break;
      case 3:
        day_label = 'Mercredi';
        break;
      case 4:
        day_label = 'Jeudi';
        break;
      case 5:
        day_label = 'Vendredi';
        break;
      case 6:
        day_label = 'Samedi';
        break;
      default:
        // code block
    }

    let month = date.getMonth() + 1;
    let month_label;
    switch(month) {
      case 1:
        month_label = 'janvier';
        break;
      case 2:
        month_label = 'février';
        break;
      case 3:
        month_label = 'mars';
        break;
      case 4:
        month_label = 'avril';
        break;
      case 5:
        month_label = 'mai';
        break;
      case 6:
        month_label = 'juin';
        break;
      case 7:
        month_label = 'juillet';
        break;
      case 8:
        month_label = 'août';
        break;
      case 9:
        month_label = 'septembre';
        break;
      case 10:
        month_label = 'octobre';
        break;
      case 11:
        month_label = 'novembre';
        break;
      case 12:
        month_label = 'décembre';
        break;
      default:
        // code block
    }
    
    let return_label = '';
    if (weekday){
      return_label += day_label + ' ';
    }

    if (day){
      return_label += date.getDate() + ' ' + month_label + ' ';
    }

    if (year){
      return_label += date.getFullYear();
    }

    return return_label;
};

export const beautifyDateTranslated = (date, t, weekday = true, day = true, year = false) => {
    
  const isToday = (someDate) => {
      const today = new Date();
      return someDate.getDate() === today.getDate() &&
          someDate.getMonth() === today.getMonth() &&
          someDate.getFullYear() === today.getFullYear();
  };

  if (isToday(date)) {
      return t('common.today'); 
  }

  // Use schedule.days for days of week (already exists)
  const daysOfWeek = [
      t('schedule.days.monday'),
      t('schedule.days.tuesday'),
      t('schedule.days.wednesday'),
      t('schedule.days.thursday'),
      t('schedule.days.friday'),
      t('schedule.days.saturday'),
      t('schedule.days.sunday')
  ];
  
  // Access months array directly - t() should return the array
  const monthsArray = t('common.months');
  const months = Array.isArray(monthsArray) ? monthsArray : [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
  ];

  // Getting the day of the week and adjusting for array starting with Monday
  let the_day = date.getDay();
  let day_label = daysOfWeek[(the_day + 6) % 7]; // Adjusting for Sunday to be the last

  let month = date.getMonth();
  let month_label = months[month]; // Using the month index as is, since months array is expected to be 0-based in this setup
  
  let return_label = '';
  if (weekday) {
    return_label += day_label + ' ';
  }

  if (day) {
    return_label += date.getDate() + ' ' + month_label + ' ';
  }

  if (year) {
    return_label += date.getFullYear();
  }

  return return_label.trim();
};


export const formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

/**
 * Build API pickup_deadline from a time-only form value ("HH:mm").
 * Preserves the calendar day from an existing multi-day flexible window, but
 * never lets the deadline date land before the new pickup/deferred date.
 */
export function anchorPickupDeadlineForSubmit(pickupDeadline, {
    pickupStartDate = null,
    orderDeferredTime = null,
    existingPickupTime = null,
    existingPickupDeadline = null,
} = {}) {
    if (!pickupDeadline) {
        return null;
    }

    if (!/^\d{1,2}:\d{2}/.test(pickupDeadline)) {
        return pickupDeadline;
    }

    const fallbackDate = pickupStartDate
        ?? (orderDeferredTime ? orderDeferredTime.split(' ')[0] : null)
        ?? formatDate(new Date());

    if (!existingPickupDeadline) {
        return `${fallbackDate} ${pickupDeadline}`;
    }

    const existingDeadline = new Date(existingPickupDeadline);
    if (isNaN(existingDeadline)) {
        return `${fallbackDate} ${pickupDeadline}`;
    }

    const existingDeadlineDate = formatDate(existingDeadline);
    const originalPickupDate = existingPickupTime
        ? formatDate(new Date(existingPickupTime))
        : fallbackDate;
    const isMultiDayWindow = existingDeadlineDate !== originalPickupDate;

    let pickupDeadlineDate = isMultiDayWindow ? existingDeadlineDate : fallbackDate;
    if (pickupDeadlineDate < fallbackDate) {
        pickupDeadlineDate = fallbackDate;
    }

    return `${pickupDeadlineDate} ${pickupDeadline}`;
}

export const formatAsISO = (d) => {
  function z(n){return (n<10?'0':'')+n}
  return d.getFullYear() + '-' + z(d.getMonth()+1) + '-' +
         z(d.getDate()) + ' ' + z(d.getHours()) + ':' +
         z(d.getMinutes()) + ':' + z(d.getSeconds());
}

export const formatMinutesToHoursAndMinutes = (minutes) => {
  if (!minutes) return '0m'
  const totalMinutes = Math.round(Number(minutes))
  const hours = Math.floor(totalMinutes / 60)
  const remainingMinutes = totalMinutes % 60
  if (hours === 0) return `${remainingMinutes}min`
  return `${hours}h ${remainingMinutes}min`
}

export const formatTime = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    
    minutes = (minutes < 10) ? '0' + minutes.toString() : minutes.toString();
    hours = (hours < 10) ? '0' + hours.toString() : hours.toString();
    
    return hours + ':' + minutes;
}

const isSameCalendarDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

/**
 * Format a time as HH:mm, prefixing the short date (e.g. "17/07 21:00") when
 * the date is on a different calendar day than the reference date. Used so
 * multi-day "flexible" orders don't show a misleading bare time.
 */
export const formatTimeWithDateIfDifferent = (date, referenceDate) => {
    if (!date || isNaN(date)) return '';
    if (referenceDate && !isNaN(referenceDate) && isSameCalendarDay(date, referenceDate)) {
        return formatTime(date);
    }
    if (!referenceDate) {
        return formatTime(date);
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${day}/${month} ${formatTime(date)}`;
}

/**
 * Multi-day "flexible" order: pickup window end (pickup_deadline) is on a later
 * calendar day than the pickup start (pickup_time). Prefers the API-computed
 * `is_flexible_window` flag when present.
 */
export const isFlexibleWindowOrder = (order) => {
    if (!order) return false;
    if (typeof order.is_flexible_window === 'boolean') {
        return order.is_flexible_window;
    }
    if (!order.pickup_time || !order.pickup_deadline) return false;
    const start = new Date(order.pickup_time);
    const end = new Date(order.pickup_deadline);
    if (isNaN(start) || isNaN(end)) return false;
    return !isSameCalendarDay(start, end);
}

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
}

/** Digits for North-American numbers (strips a leading country-code 1). */
export function northAmericanPhoneDigits(phone) {
  const digits = String(phone ?? '').replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    return digits.slice(1);
  }
  return digits;
}

/** LAR / carrier phones: ########## or ###-###-#### (exactly 10 digits). */
export function isValidNorthAmericanPhone(phone) {
  return northAmericanPhoneDigits(phone).length === 10;
}

/** Prefix pickup apartment into PICKUP_COMMENT (no ORIG_APPT column). */
export function composePickupComment(comment, apartment) {
  const apt = String(apartment ?? '').trim();
  const cmt = String(comment ?? '').trim();
  if (!apt) {
    return cmt;
  }
  const aptPrefix = `App. ${apt}`;
  return cmt ? `${aptPrefix}. ${cmt}` : aptPrefix;
}

function SkeletonRow(){
  return (
    <div className="panel" style={{height: '4em'}}>
      <div className="skeleton-box"></div>
    </div>
  );
}

export function SkeletonRowsLoading(){
  
  var skeleton_rows = [];
  for (var i = 0; i < 5; i++) {
    skeleton_rows.push(
      <SkeletonRow key={i} />
    );
  }

  return(
    <div>
      {skeleton_rows}
    </div>
  );
}

export function isToday(someDate) {
  const today = new Date()
  return someDate.getDate() == today.getDate() &&
    someDate.getMonth() == today.getMonth() &&
    someDate.getFullYear() == today.getFullYear()
}

const DELIVERY_PAYMENT_REQUIRED_TYPES = ['COMPTANT', 'DEBIT', 'CREDIT'];

export function isDeliveryPaymentRequired(paymentType) {
  if (!paymentType) {
    return false;
  }

  return DELIVERY_PAYMENT_REQUIRED_TYPES.includes(String(paymentType).toUpperCase());
}

export function sortDrivers(firstDriver, secondDriver) {
  if (firstDriver.status < secondDriver.status) {
    return -1;
  }else if (firstDriver.status > secondDriver.status) {
    return 1;
  }
  // a must be equal to b
  return 0;
}

export function sortDriverOrders(firstOrder, secondOrder) {
  if (firstOrder.deliveryIndex < secondOrder.deliveryIndex) {
    return -1;
  }else if (firstOrder.deliveryIndex > secondOrder.deliveryIndex) {
    return 1;
  }
  // a must be equal to b
  return 0;
}

export function getDistanceFromLatLon(lat1, lon1, lat2, lon2) {
  const R = 6371e3; // metres
  const q1 = lat1 * Math.PI/180; // φ, λ in radians
  const q2 = lat2 * Math.PI/180;
  const dq = (lat2-lat1) * Math.PI/180;
  const da = (lon2-lon1) * Math.PI/180;

  const a = Math.sin(dq/2) * Math.sin(dq/2) +
            Math.cos(q1) * Math.cos(q2) *
            Math.sin(da/2) * Math.sin(da/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

  const d = (R * c)/1000;

  return d.toFixed(2);
}

export function getDiffTimeFromNow(now, status, order_pickup_time, order_delivered_time){
  let pickup_time = new Date(order_pickup_time);
  let diffMs;
  if ((status == 'LIVRÉ') || (status == 'ANNULÉ') || (status == 'ÉCHEC') || (status == 'RETOUR')){
      let delivered_time = new Date(order_delivered_time);
      diffMs = delivered_time - pickup_time;
      if (diffMs < 0) {
          diffMs = 0;
      }
  }else{
      diffMs = now - pickup_time;
  }

  return Math.floor((diffMs/1000)/60);
}

export const getDateTime = (dateTime, additionalMinutes = 0) => {
  const date = new Date(dateTime);

  // Add the specified minutes to the date
  date.setMinutes(date.getMinutes() + additionalMinutes);

  // Convert to New York time zone
  const newYorkTime = new Intl.DateTimeFormat('en-US', { 
      timeZone: 'America/New_York', 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
  }).format(date);

  const [month, day, year, hour, minute] = newYorkTime.match(/\d+/g);

  const dateStr = `${year}-${month}-${day}`;
  const timeStr = `${hour}:${minute}`;

  return { date: dateStr, time: timeStr };
}

export const onlineDriverMarker = 'https://chart.apis.google.com/chart?chst=d_map_spin&chld=0.8|0|23ECF6|12|_|';
export const busyDriverMarker = 'http://chart.apis.google.com/chart?chst=d_map_spin&chld=0.8|0|FE9E00|12|_|';
export const driverStatusTracking = ['EN DIRECTION', 'ASSIGNÉ', 'ARRIVÉ', 'RÉCUPÉRÉE', 'EN ROUTE'];

export const mapOptionsNoUi = {
  disableDefaultUI: true,
  fullscreenControl: true,
  styles: [
    {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [
          {
              "visibility": "off"
          }
      ]
    },
  ]
};

export const mapOptions = {
  styles: [
    {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [
          {
              "visibility": "off"
          }
      ]
    },
    {
      "featureType": "administrative",
      "elementType": "all",
      "stylers": [
        {
            "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [
        {
            "visibility": "off"
        }
      ]
    },
  ]
};

export const canAccess = (user, accessArray) => {
  // Check if user is null or not defined
  if (!user || !user.roles) {
      return false;
  }

  const userRoleNames = user.roles.map(role => role.name);

  for (let role of accessArray) {
      if (userRoleNames.includes(role)) {
          return true;
      }
  }

  return false;
};

export const isDispatchReadOnly = (user) => canAccess(user, ['dispatch_readonly']);

export const canMutateDispatch = (user) => {
  if (isDispatchReadOnly(user)) {
      return false;
  }

  return canAccess(user, ['dispatch', 'admin', 'dispatcher', 'accountant', 'hr']);
};

/** True if the user has any merchant-side role (e.g. merchant, merchant_dispatcher). */
export const isMerchantUser = (user) =>
  canAccess(user, Object.values(MERCHANT_ROLES_MAPPING));

export const getTagColor = (id) => {
  // Convert the ID to a color
  const hexId = (id * 9301 + 49297) % 16777215; // Use some prime numbers to spread the values
  // Convert the value to a hex string
  return `#${hexId.toString(16).padStart(6, '0')}`;
};

export const timeEstimate = (driverDistance) => {
  if (driverDistance < 2){
      return '0-5';
  }else if(driverDistance < 5){
      return '5-10';
  }else if(driverDistance < 8){
      return '10-15';
  }else if(driverDistance < 10){
      return '15-20';
  }else if(driverDistance <= 12){
      return '20-25';
  }else if(driverDistance > 12){
      return '+25';
  }
}

export const clientTimeEstimate = (driverClientDistance) => {
  if (driverClientDistance < 2){
      return '0-5';
  }else if(driverClientDistance < 5){
      return '5-10';
  }else if(driverClientDistance < 8){
      return '10-15';
  }else if(driverClientDistance < 10){
      return '15-20';
  }else if(driverClientDistance <= 12){
      return '20-25';
  }else if(driverClientDistance > 12){
      return '+25';
  }
}

export function filterOrders(orders, filterCriteria) {
  let filteredOrders = orders;

  if (filterCriteria) {
      if (filterCriteria.date) {
          filteredOrders = filteredOrders.filter(order => {
              const orderDate = new Date(order.pickup_time);
              const filterDate = new Date(filterCriteria.date + "T00:00:00");
          
              return orderDate.getFullYear() === filterDate.getFullYear() &&
                     orderDate.getMonth() === filterDate.getMonth() &&
                     orderDate.getDate() === filterDate.getDate();
          });
      }
      
      if (filterCriteria.search) {
         // Convert the search criteria to lower case
         const lowerCaseSearch = filterCriteria.search.toLowerCase();

        filteredOrders = filteredOrders.filter(order => {
            // Perform a case-insensitive check by converting the compared strings to lower case
              const addressMatch = order.destination && order.destination.address && order.destination.address.toLowerCase().includes(lowerCaseSearch);
              const fullnameMatch = order.driver && order.driver.fullname && order.driver.fullname.toLowerCase().includes(lowerCaseSearch);
              const phoneMatch = order.destination && order.destination.phone && order.destination.phone.includes(lowerCaseSearch);
              const merchantNameMatch = order.merchant && order.merchant.name && order.merchant.name.toLowerCase().includes(lowerCaseSearch);
              return addressMatch || fullnameMatch || phoneMatch || merchantNameMatch;
        });
      }
  }

  return filteredOrders;
}

export const getOrderStatusTranslated = (status, t) => {
  switch (status) {
    case 'A CONFIRMER':
      return t('common.orderStatus.toConfirm');
    case 'EN ATTENTE':
      return t('common.orderStatus.onWait');
    case 'ASSIGNÉ':
      return t('common.orderStatus.assigned');
    case 'EN DIRECTION':
      return t('common.orderStatus.headingToPickup');
    case 'ARRIVÉ':
      return t('common.orderStatus.arrived');
    case 'RÉCUPÉRÉE':
      return t('common.orderStatus.pickedUp');
    case 'EN ROUTE':
      return t('common.orderStatus.onTheWay');
    case 'ANNULÉ':
      return t('common.orderStatus.cancelled');
    case 'ÉCHEC':
      return t('common.orderStatus.failed');
    case 'REFUSÉE':
      return t('common.orderStatus.refused');
    case 'LIVRÉ':
      return t('common.orderStatus.delivered');
    case 'ATTENTION':
      return t('common.orderStatus.attention');
    case 'TRANSIT':
      return t('common.orderStatus.transit');
    case 'EN RETOUR':
      return t('common.orderStatus.returning');
    case 'RETOUR':
      return t('common.orderStatus.returned');
    default:
      return "unknown status";
  }
};

// Utility function to handle UTF-8 conversion
export function fixFrenchAccents(text) {
  try {
      // Handle null or undefined values
      if (!text) return '';

      // Mapping of incorrectly encoded characters to their correct equivalents
      const charMap = {
          'Ã©': 'é', 'Ã¨': 'è', 'Ã«': 'ë', 'Ãª': 'ê', 'Ã§': 'ç', 'Ã¢': 'â',
          'Ã ': 'à', 'Ã®': 'î', 'Ã¯': 'ï', 'Ã´': 'ô', 'Ã¹': 'ù', 'Ã»': 'û',
          'Å"': 'œ', 'Ã‰': 'É', 'Ãˆ': 'È', 'Ã€': 'À', '√©': 'é', '√¨': 'è',
          '√«': 'ë', '√™': 'ê', '√ß': 'ç', '√¢': 'â', '√ ': 'à', '√®': 'î',
          '√¯': 'ï', '√´': 'ô', '√¹': 'ù', '√»': 'û', '√‰': 'É', '√ˆ': 'È',
          '√€': 'À', '√¥': 'ô', '\\?©': 'é', '\\?¨': 'è', '\\?™': 'è',
          '\\?«': 'ë', '\\?®': 'ê', '\\?§': 'ç', '\\?¢': 'â', '\\?´': 'à',
          '\\?¥': 'ô', '\\?¯': 'ï', '\\?®': 'î', '\\?±': 'ñ', '\\?³': 'ù',
          '\\?²': 'ú', '\\?µ': 'µ', '\\?¶': 'ö', '\\?†': 'à', '\\?‡': 'ç',
          '\\?' : 'é'
      };

      // Replace incorrect characters using the mapping
      Object.keys(charMap).forEach((key) => {
          const regex = new RegExp(key, 'g');
          text = text.replace(regex, charMap[key]);
      });

      return text;
  } catch (error) {
      console.error('French accent correction error:', error);
      return text; // Return original text if conversion fails
  }
  
}

export const floatToPercentage = (value) => {
  if (value === null || value === undefined) return '0%';
  return `${Math.round(value * 100)}%`;
};

/**
 * Find the active delivery from an order's deliveries array.
 * Active delivery: not delivered or cancelled, with smallest sequence.
 * 
 * @param {Object} order - The order object that may contain a deliveries array
 * @returns {Object|null} - The active delivery object or null if none found
 */
export const findActiveDelivery = (order) => {
  if (!order || !order.deliveries || !Array.isArray(order.deliveries) || order.deliveries.length === 0) {
    return null;
  }

  const activeDeliveries = order.deliveries
    .filter(d => d.status !== 'LIVRÉ' && d.status !== 'ANNULÉ' && d.status !== 'ÉCHEC' && d.status !== 'RETOUR');

  if (activeDeliveries.length === 0) {
    return null;
  }

  // Sort by sequence (check both sequence and SEQUENCE for different casing)
  activeDeliveries.sort((a, b) => {
    const seqA = a.sequence !== undefined ? a.sequence : (a.SEQUENCE !== undefined ? a.SEQUENCE : Infinity);
    const seqB = b.sequence !== undefined ? b.sequence : (b.SEQUENCE !== undefined ? b.SEQUENCE : Infinity);
    return seqA - seqB;
  });

  return activeDeliveries[0] || null;
};

/**
 * Find the last delivery from an order's deliveries array by sequence.
 * Last delivery: the delivery with the highest sequence number.
 * 
 * @param {Object} order - The order object that may contain a deliveries array
 * @returns {Object|null} - The last delivery object or null if none found
 */
export const findLastDeliveryBySequence = (order) => {
  if (!order || !order.deliveries || !Array.isArray(order.deliveries) || order.deliveries.length === 0) {
    return null;
  }

  // Sort by sequence descending (check both sequence and SEQUENCE for different casing)
  const sortedDeliveries = [...order.deliveries].sort((a, b) => {
    const seqA = a.sequence !== undefined ? a.sequence : (a.SEQUENCE !== undefined ? a.SEQUENCE : -Infinity);
    const seqB = b.sequence !== undefined ? b.sequence : (b.SEQUENCE !== undefined ? b.SEQUENCE : -Infinity);
    return seqB - seqA; // Descending order
  });

  return sortedDeliveries[0] || null;
};

/**
 * Find the first delivery from an order's deliveries array by sequence.
 * First delivery: the delivery with the lowest sequence number.
 * 
 * @param {Object} order - The order object that may contain a deliveries array
 * @returns {Object|null} - The first delivery object or null if none found
 */
export const findFirstDeliveryBySequence = (order) => {
  if (!order || !order.deliveries || !Array.isArray(order.deliveries) || order.deliveries.length === 0) {
    return null;
  }

  // Sort by sequence ascending (check both sequence and SEQUENCE for different casing)
  const sortedDeliveries = [...order.deliveries].sort((a, b) => {
    const seqA = a.sequence !== undefined ? a.sequence : (a.SEQUENCE !== undefined ? a.SEQUENCE : Infinity);
    const seqB = b.sequence !== undefined ? b.sequence : (b.SEQUENCE !== undefined ? b.SEQUENCE : Infinity);
    return seqA - seqB; // Ascending order
  });

  return sortedDeliveries[0] || null;
};

/**
 * Resolve a delivery leg sequence number from mixed API shapes.
 *
 * @param {Object} delivery
 * @returns {number}
 */
export const getDeliverySequence = (delivery) => {
  if (!delivery) return 1;
  const sequence = delivery.sequence ?? delivery.SEQUENCE;
  const parsed = Number(sequence);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
};

/**
 * Format order hex with optional multi-leg suffix (e.g. ABC123-2).
 *
 * @param {string|Object} orderOrHex
 * @param {number} [sequence]
 * @returns {string}
 */
export const formatOrderHexWithSegment = (orderOrHex, sequence) => {
  const hex = typeof orderOrHex === 'string'
    ? orderOrHex
    : (orderOrHex?.hex ?? '');
  const seq = sequence ?? getDeliverySequence(orderOrHex);
  return `${hex}${seq > 1 ? `-${seq}` : ''}`;
};

export const hasIncompleteParentLeg = (order) => Boolean(order?.parent_leg_incomplete);

export const selectedOrdersHaveIncompleteParentLeg = (orders = []) => {
  const list = Array.isArray(orders) ? orders : [orders];
  return list.some(hasIncompleteParentLeg);
};

export const isPickupDeliveryAlreadySplit = (order) => {
  if (!order) return false;
  if (order.omit_pickup_stop || order.omit_delivery_stop) return true;
  const active = order.activeDelivery;
  return Boolean(active?.omit_pickup_stop || active?.omit_delivery_stop);
};

const SPLIT_DELIVERY_TERMINAL = new Set(['COMPLÉTÉ', 'LIVRÉ', 'ANNULÉ', 'ÉCHEC', 'RETOUR']);
const SPLIT_FIRST_LEG_BLOCKING = new Set(['ANNULÉ', 'ÉCHEC', 'RETOUR']);

function getSplitItemStatus(item) {
  return item?.status ?? item?.STATUS ?? item?.activeDelivery?.status;
}

function getSplitOrderId(item) {
  return item?.ORID ?? item?.orid ?? item?.activeDelivery?.ORID ?? item?.activeDelivery?.orid ?? null;
}

function isDeliveryOnlySplitLeg(item) {
  if (!item) return false;
  const omitPickup = Boolean(item.omit_pickup_stop || item.activeDelivery?.omit_pickup_stop);
  const omitDelivery = Boolean(item.omit_delivery_stop || item.activeDelivery?.omit_delivery_stop);
  return omitPickup && !omitDelivery;
}

function collectSplitSiblingDeliveries(order, extraSiblings) {
  const siblings = [];
  if (Array.isArray(order?.deliveries)) siblings.push(...order.deliveries);
  if (order?.activeDelivery) siblings.push(order.activeDelivery);
  if (Array.isArray(extraSiblings)) siblings.push(...extraSiblings);
  return siblings;
}

/** Delivery-only child of a split pair, matching API resolveSplitPickupDeliveryPair. */
function findPairedDeliveryOnlyLeg(order, siblings) {
  if (isDeliveryOnlySplitLeg(order)) return order.activeDelivery ?? order;

  const orderId = getSplitOrderId(order);
  const currentSeq = getDeliverySequence(order.activeDelivery ?? order);
  const matches = siblings.filter((item) => {
    if (!isDeliveryOnlySplitLeg(item)) return false;
    const siblingOrderId = getSplitOrderId(item);
    if (orderId != null && siblingOrderId != null && String(orderId) !== String(siblingOrderId)) {
      return false;
    }
    return getDeliverySequence(item) > currentSeq;
  });

  if (matches.length === 0) return null;
  matches.sort((a, b) => getDeliverySequence(a) - getDeliverySequence(b));
  return matches[0];
}

/** True when this row is a split pickup/delivery leg whose delivery segment is still open. */
export const canReunitePickupDelivery = (order, siblingDeliveries) => {
  if (!isPickupDeliveryAlreadySplit(order)) return false;
  const omitPickup = Boolean(order.omit_pickup_stop || order.activeDelivery?.omit_pickup_stop);
  const omitDelivery = Boolean(order.omit_delivery_stop || order.activeDelivery?.omit_delivery_stop);
  const status = getSplitItemStatus(order);
  if (omitPickup && SPLIT_DELIVERY_TERMINAL.has(status)) return false;
  if (omitDelivery && SPLIT_FIRST_LEG_BLOCKING.has(status)) return false;

  const pairedDelivery = findPairedDeliveryOnlyLeg(
    order,
    collectSplitSiblingDeliveries(order, siblingDeliveries),
  );
  if (pairedDelivery) {
    const pairStatus = getSplitItemStatus(pairedDelivery);
    if (SPLIT_DELIVERY_TERMINAL.has(pairStatus)) return false;
  } else if (omitDelivery && order.activeDelivery === null && SPLIT_DELIVERY_TERMINAL.has(status)) {
    // Completed order detail: omit flags come from the pickup-only first delivery.
    return false;
  }

  return true;
};

/**
 * Order-level Livreur total: sum of delivery driver costs + external shipment cost.
 *
 * @param {Object|null|undefined} order
 * @returns {number|null}
 */
export const getOrderLivreurCost = (order) => {
  if (!order) {
    return null;
  }

  const deliveries = order.deliveries ?? [];
  const hasExternal =
    order.external_shipment != null ||
    order.external_shipment_cost != null ||
    order.has_external_shipment;

  const deliveryTotal = deliveries.reduce((sum, delivery) => {
    if (delivery?.driver_commission == null || delivery.driver_commission === '') {
      return sum;
    }
    const amount = Number(delivery.driver_commission);
    return sum + (Number.isNaN(amount) ? 0 : amount);
  }, 0);

  const externalRaw =
    order.external_shipment?.third_party_pricing ??
    order.external_shipment_cost ??
    0;
  const externalAmount = Number(externalRaw);
  const externalTotal = Number.isNaN(externalAmount) ? 0 : externalAmount;

  if (deliveries.length > 0 || hasExternal) {
    return deliveryTotal + externalTotal;
  }

  if (order.driver_commission == null || order.driver_commission === '') {
    return null;
  }

  const fallback = Number(order.driver_commission);
  return Number.isNaN(fallback) ? null : fallback;
};

/**
 * Build the dispatch delivery detail view for a specific order leg.
 * When segment is omitted, returns the order unchanged (API default leg).
 *
 * @param {Object|null} order
 * @param {string|number|null|undefined} segment 1-based delivery sequence
 * @returns {Object|null}
 */
export const resolveDeliverySegmentOrder = (order, segment) => {
  if (!order) {
    return null;
  }

  if (segment == null || segment === '') {
    return order;
  }

  const segmentNum = Number(segment);
  if (!Number.isFinite(segmentNum) || segmentNum < 1) {
    return order;
  }

  const deliveries = order.deliveries ?? [];
  if (deliveries.length === 0) {
    return order;
  }

  const delivery = deliveries.find((item) => getDeliverySequence(item) === segmentNum);
  if (!delivery) {
    return null;
  }

  const orid = order.ORID ?? order.orid ?? order.id;
  const orderDestination =
    order.order_destination ??
    delivery.order_destination ??
    order.destination;
  const destination = delivery.destination
    ? {
        ...delivery.destination,
        email: delivery.destination.email ?? order.destination?.email,
      }
    : order.destination;

  return {
    ...order,
    ...delivery,
    id: orid,
    ORID: orid,
    orid,
    hex: order.hex ?? delivery.hex,
    merchant: delivery.merchant ?? order.merchant,
    destination,
    order_destination: orderDestination,
    deliveries,
    external_shipment: order.external_shipment,
    activeDelivery: delivery,
    selectedSegment: segmentNum,
    sequence: getDeliverySequence(delivery),
    service_type: order.service_type,
    // Merchant fee is order-level; do not let a null leg field wipe it after the spread.
    commission: order.commission ?? delivery.commission,
    package_count: delivery.package_count ?? order.package_count,
    package_size: delivery.package_size ?? order.package_size,
    has_accessible_dimensions: order.has_accessible_dimensions,
    pickup_procedure: order.pickup_procedure,
    dropoff_procedure: order.dropoff_procedure,
    DELID: delivery.DELID ?? delivery.id,
  };
};